import api from './api';

async function getAll() {
  return api.get('/participantes_toolbox');
}
// Returns every participant registered for a toolbox session.
async function getBySesion(sesionId) {
  return api.get(
    `/participantes_toolbox?sesionId=${encodeURIComponent(sesionId)}`
  );
}

// Creates one toolbox participant.
async function create(data) {
  return api.post('/participantes_toolbox', data);
}

// Removes one toolbox participant.
async function remove(id) {
  return api.delete(`/participantes_toolbox/${id}`);
}

// Creates many toolbox participants in sequence.
async function bulkCreate(participantesArray) {
  return Promise.all(participantesArray.map((participante) => create(participante)));
}

const participanteToolboxService = {
  getAll,
  getBySesion,
  create,
  remove,
  bulkCreate,
};

export default participanteToolboxService;
